/**
 * Enum containing all possible label types that Datawedge is compatible with. Includes lookup
 * capability. Based upon the table found on this page of Datawedge docs:
 * https://techdocs.zebra.com/datawedge/13-0/guide/output/intent/
 */
export enum ZebraLabelType {
    'LABEL-TYPE-CODE39' = 'LABEL-TYPE-CODE39',
    'LABEL-TYPE-CODABAR' = 'LABEL-TYPE-CODABAR',
    'LABEL-TYPE-CODE128' = 'LABEL-TYPE-CODE128',
    'LABEL-TYPE-D2OF5' = 'LABEL-TYPE-D2OF5',
    'LABEL-TYPE-IATA2OF5' = 'LABEL-TYPE-IATA2OF5',
    'LABEL-TYPE-I2OF5' = 'LABEL-TYPE-I2OF5',
    'LABEL-TYPE-CODE93' = 'LABEL-TYPE-CODE93',
    'LABEL-TYPE-UPCA' = 'LABEL-TYPE-UPCA',
    'LABEL-TYPE-UPCE0' = 'LABEL-TYPE-UPCE0',
    'LABEL-TYPE-UPCE1' = 'LABEL-TYPE-UPCE1',
    'LABEL-TYPE-EAN8' = 'LABEL-TYPE-EAN8',
    'LABEL-TYPE-EAN13' = 'LABEL-TYPE-EAN13',
    'LABEL-TYPE-MSI' = 'LABEL-TYPE-MSI',
    'LABEL-TYPE-EAN128' = 'LABEL-TYPE-EAN128',
    'LABEL-TYPE-TRIOPTIC39' = 'LABEL-TYPE-TRIOPTIC39',
    'LABEL-TYPE-BOOKLAND' = 'LABEL-TYPE-BOOKLAND',
    'LABEL-TYPE-COUPON' = 'LABEL-TYPE-COUPON',
    'LABEL-TYPE-DATABAR-COUPON' = 'LABEL-TYPE-DATABAR-COUPON',
    'LABEL-TYPE-ISBT128' = 'LABEL-TYPE-ISBT128',
    'LABEL-TYPE-CODE32' = 'LABEL-TYPE-CODE32',
    'LABEL-TYPE-PDF417' = 'LABEL-TYPE-PDF417',
    'LABEL-TYPE-MICROPDF' = 'LABEL-TYPE-MICROPDF',
    'LABEL-TYPE-TLC39' = 'LABEL-TYPE-TLC39',
    'LABEL-TYPE-CODE11' = 'LABEL-TYPE-CODE11',
    'LABEL-TYPE-MAXICODE' = 'LABEL-TYPE-MAXICODE',
    'LABEL-TYPE-DATAMATRIX' = 'LABEL-TYPE-DATAMATRIX',
    'LABEL-TYPE-QRCODE' = 'LABEL-TYPE-QRCODE',
    'LABEL-TYPE-GS1-DATABAR' = 'LABEL-TYPE-GS1-DATABAR',
    'LABEL-TYPE-GS1-DATABAR-LIM' = 'LABEL-TYPE-GS1-DATABAR-LIM',
    'LABEL-TYPE-GS1-DATABAR-EXP' = 'LABEL-TYPE-GS1-DATABAR-EXP',
    'LABEL-TYPE-USPOSTNET' = 'LABEL-TYPE-USPOSTNET',
    'LABEL-TYPE-USPLANET' = 'LABEL-TYPE-USPLANET',
    'LABEL-TYPE-UKPOSTAL' = 'LABEL-TYPE-UKPOSTAL',
    'LABEL-TYPE-JAPPOSTAL' = 'LABEL-TYPE-JAPPOSTAL',
    'LABEL-TYPE-AUSPOSTAL' = 'LABEL-TYPE-AUSPOSTAL',
    'LABEL-TYPE-DUTCHPOSTAL' = 'LABEL-TYPE-DUTCHPOSTAL',
    'LABEL-TYPE-FINNISHPOSTAL-4S' = 'LABEL-TYPE-FINNISHPOSTAL-4S',
    'LABEL-TYPE-CANPOSTAL' = 'LABEL-TYPE-CANPOSTAL',
    'LABEL-TYPE-CHINESE-2OF5' = 'LABEL-TYPE-CHINESE-2OF5',
    'LABEL-TYPE-AZTEC' = 'LABEL-TYPE-AZTEC',
    'LABEL-TYPE-MICROQR' = 'LABEL-TYPE-MICROQR',
    'LABEL-TYPE-US4STATE' = 'LABEL-TYPE-US4STATE',
    'LABEL-TYPE-US4STATE-FICS' = 'LABEL-TYPE-US4STATE-FICS',
    'LABEL-TYPE-COMPOSITE-AB' = 'LABEL-TYPE-COMPOSITE-AB',
    'LABEL-TYPE-COMPOSITE-C' = 'LABEL-TYPE-COMPOSITE-C',
    'LABEL-TYPE-WEBCODE' = 'LABEL-TYPE-WEBCODE',
    'LABEL-TYPE-SIGNATURE' = 'LABEL-TYPE-SIGNATURE',
    'LABEL-TYPE-KOREAN-3OF5' = 'LABEL-TYPE-KOREAN-3OF5',
    'LABEL-TYPE-MATRIX-2OF5' = 'LABEL-TYPE-MATRIX-2OF5',
    'LABEL-TYPE-OCR' = 'LABEL-TYPE-OCR',
    'LABEL-TYPE-HANXIN' = 'LABEL-TYPE-HANXIN',
    'LABEL-TYPE-MAILMARK' = 'LABEL-TYPE-MAILMARK',
    'MULTICODE-DATA-FORMAT' = 'MULTICODE-DATA-FORMAT',
    'LABEL-TYPE-GS1-DATAMATRIX' = 'LABEL-TYPE-GS1-DATAMATRIX',
    'LABEL-TYPE-GS1-QRCODE' = 'LABEL-TYPE-GS1-QRCODE',
    'LABEL-TYPE-DOTCODE' = 'LABEL-TYPE-DOTCODE',
    'LABEL-TYPE-GRIDMATRIX' = 'LABEL-TYPE-GRIDMATRIX',
    'LABEL-TYPE-UNDEFINED' = 'LABEL-TYPE-UNDEFINED',
}
